module.exports = __webpack_public_path__ + "static/media/doctorAndLabtop.f1d008fa.svg";